/**
 * @generated SignedSource<<ff7933c6a8cb7f7455dce6d4f26f000f>>
 * @relayHash b7c794d725ced4845d1bb9a59073c524
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2005579a94ce4be7573532442ba5ad55205f8ec6475e96e2ea73ef75a1d94071

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ContentSpecificCreateInput = {
  key: string;
  value: string;
};
export type CreateWhiteboardMutation$variables = {
  contentSpecificCreateInput?: ReadonlyArray<ContentSpecificCreateInput> | null | undefined;
  parentId?: string | null | undefined;
  spaceKey: string;
  title?: string | null | undefined;
};
export type CreateWhiteboardMutation$data = {
  readonly createContentContextual: {
    readonly id: string | null | undefined;
    readonly space: {
      readonly alias: string | null | undefined;
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CreateWhiteboardMutation = {
  response: CreateWhiteboardMutation$data;
  variables: CreateWhiteboardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentSpecificCreateInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentSpecificCreateInput",
            "variableName": "contentSpecificCreateInput"
          },
          {
            "kind": "Variable",
            "name": "parentId",
            "variableName": "parentId"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          },
          {
            "kind": "Literal",
            "name": "status",
            "value": "CURRENT"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          },
          {
            "kind": "Literal",
            "name": "type",
            "value": "whiteboard"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "createContentContextual",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "alias"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CreateWhiteboardMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateWhiteboardMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "b7c794d725ced4845d1bb9a59073c524",
    "id": "2005579a94ce4be7573532442ba5ad55205f8ec6475e96e2ea73ef75a1d94071",
    "metadata": {},
    "name": "CreateWhiteboardMutation",
    "operationKind": "mutation",
    "text": "mutation CreateWhiteboardMutation($spaceKey:String!,$parentId:ID,$contentSpecificCreateInput:[ContentSpecificCreateInput!],$title:String){createContentContextual(input:{spaceKey:$spaceKey,parentId:$parentId,contentSpecificCreateInput:$contentSpecificCreateInput,status:CURRENT,type:\"whiteboard\",title:$title}){id,space{id,key,alias}}}"
  }
};
})();

(node as any).hash = "e930261bfff63c39536ae377f7405d1c";

export default node;
